import script from "./AppSpinKit.vue?vue&type=script&setup=true&lang=js"
export * from "./AppSpinKit.vue?vue&type=script&setup=true&lang=js"

import "./AppSpinKit.vue?vue&type=style&index=0&id=6996474a&scoped=true&lang=css"

import exportComponent from "/home/runner/work/adaptif-frontend/adaptif-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6996474a"]])

export default __exports__